import { Badge } from "@mantine/core";

const MantineBadge = (props: any) => {
    const {
        children,
        color,
        gradient,
        size,
        variant,
        leftSection,
        rightSection,
        radius
    } = props;
    return (
        <Badge
            color={color}
            gradient={gradient}
            size={size}
            variant={variant}
            radius={radius}
            leftSection={leftSection}
            rightSection={rightSection}
        >
            {children}
        </Badge>
    );
};

export default MantineBadge;